document.addEventListener('DOMContentLoaded', () => {
    const blogDropdownTrigger = document.getElementsByClassName('blog-header-mobile-dropdown-trigger');
    for (let i = 0; i < blogDropdownTrigger.length; i++) {
        let trigger = blogDropdownTrigger[i];
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            let dropdown = document.getElementById(trigger.dataset.dropdownid);
            dropdown.classList.toggle('open');
            trigger.classList.toggle('open');
        });
    }
});
